import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
};

export const wicketTypeSlice = createSlice({
  name: "wicketType",
  initialState: initialState,
  reducers: {
    setWicketTypeData: (state, action) => {
      console.log("wicketType action => ", action.payload.data);
      state.data = action.payload.data;
    },
  },
});

export const { setWicketTypeData } = wicketTypeSlice.actions;
export default wicketTypeSlice.reducer;
